import Repository from "@shared/services/api/abstracts/Repository";
import { PublicBaseLocationSerializer } from "../types/seating-types";

export default class PublicBasedLocationRepository extends Repository<
  Array<PublicBaseLocationSerializer>
> {
  public readonly repositoryName = "PublicBasedLocationRepository";

  public readonly endpoint = "/api/public/venues/locations/";
}
